import cn from 'classnames'
import { func, node, number, string } from 'prop-types'
import React, { useState } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'

import { handleEnter } from './utils'
import styles from './Truncate.module.scss'

const ToggleButton = ({ children, className = '', onClick, onKeyPress }) => (
  <button
    onClick={onClick}
    onKeyPress={onKeyPress}
    className={cn(
      'mc-text--link mc-text--capitalize mc-p-0',
      className,
      styles.button,
    )}
  >
    {children}
  </button>
)

ToggleButton.propTypes = {
  children: node.isRequired,
  className: string,
  onClick: func.isRequired,
  onKeyPress: func.isRequired,
}

export const Truncate = ({
  text,
  textStyle,
  maxLine,
  showMoreText,
  showLessText,
}) => {
  const [isShowingMore, setIsShowingMore] = useState(false)
  const toggleIsShowingMore = () =>
    setIsShowingMore((_isShowingMore) => !_isShowingMore)

  const toggleButtonProps = {
    className: textStyle,
    onClick: toggleIsShowingMore,
    onKeyPress: handleEnter(toggleIsShowingMore),
  }

  if (!text) return null

  if (isShowingMore) {
    return (
      <p className={cn(styles.text, textStyle)}>
        {text}
        &nbsp;
        <ToggleButton {...toggleButtonProps}>{showLessText}</ToggleButton>
      </p>
    )
  }

  return (
    <div className={styles.text}>
      <LinesEllipsis
        basedOn='words'
        component='p'
        maxLine={maxLine}
        className={cn(styles.text, textStyle)}
        ellipsis={
          <span>
            {'... '}
            <ToggleButton {...toggleButtonProps}>{showMoreText}</ToggleButton>
          </span>
        }
        text={text}
      />
    </div>
  )
}

Truncate.propTypes = {
  maxLine: number.isRequired,
  text: string.isRequired,
  textStyle: string,
  showMoreText: string.isRequired,
  showLessText: string.isRequired,
}
